import React, { useEffect, useState } from 'react';
import InputLabel from '@mui/material/InputLabel';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
// import { reactPlugin } from '../../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { jsonEditorStyles } from '../jsonEditorStyles';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { TextComponent, SelectComponent } from '../../uiComponents';
import { SelectChangeEvent } from '@mui/material';
import { useSelector } from 'react-redux';

interface componentProps {
  modifiedData: any;
  changeHandler: any;
  sessionTypes: string;
}

export const sessionFieldsAreValid = (modifiedData: any) => {
  return (
    (!modifiedData['sessionManagement']) ||
    (modifiedData['sessionManagement']['option'] === 'alwaysExecute') ||
    (modifiedData['sessionManagement']['option'] === 'useGlobalSession') ||
    ((modifiedData['sessionManagement']['option'] === 'skipForSpecificSession') &&
      (modifiedData['sessionManagement']['sessionId']) &&
      (!modifiedData['sessionManagement']['sessionId'].includes(' ')) &&
      (!modifiedData['sessionManagement']['sessionId'].startsWith('_'))
    )
  )
}

const sessionOptions = {
  default: [
    { label: 'Store claims from this component in global SSO session', value: 'useGlobalSession' },
    { label: 'Skip this component when specific session flag exists', value: 'skipForSpecificSession'},
    { label: 'Always execute this component', value: 'alwaysExecute' },
  ],
  none: [],
};

const SessionManagement = ({ modifiedData, changeHandler, sessionTypes }: componentProps) => {
  const classes = jsonEditorStyles();
  const style = { margin: 1, width: 200 };
  return (
    <>
      {(!modifiedData.subflowParent) && (
        <div className={classes.flexCol}>
          <div className={classes.subHeading}>Session Management</div>
          <div className={classes.flexRow}>
            <SelectComponent
              changeHandler={(e: SelectChangeEvent<any>) => {
                changeHandler({
                  ...modifiedData,
                  sessionManagement: { ...modifiedData['sessionManagement'], option: e.target.value },
                });
              }}
              data={{
                value: modifiedData.sessionManagement.option,
                label: 'Session Management',
                options: sessionOptions[sessionTypes as keyof typeof sessionOptions],
                style: { margin: 1, width: 300 },
              }}
            />
          </div>
          {modifiedData.sessionManagement.option === 'skipForSpecificSession' && (
            <div className={classes.flexRow}>
              <TextComponent
                changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
                  changeHandler({
                    ...modifiedData,
                    sessionManagement: { ...modifiedData['sessionManagement'], sessionId: e.target.value },
                  });
                }}
                data={{
                  label: 'Session Flag',
                  required: true,
                  value: modifiedData.sessionManagement.sessionId ? modifiedData.sessionManagement.sessionId : '',
                  error: modifiedData['sessionManagement'].sessionId.includes(' ') || modifiedData['sessionManagement'].sessionId.startsWith('_'),
                  helperText: modifiedData['sessionManagement'].sessionId.includes(' ') ? 'Session flag may not contain spaces' :
                    (modifiedData['sessionManagement'].sessionId.startsWith('_') ? 'Session flag may not begin with an underscore' : '')
                }}
              />
            </div>
          )}
        </div>
      )}
    </>
  );
};
// export default withAITracking(reactPlugin, SessionManagement);
export default SessionManagement;
